import {
  PRODUCT_COUNT_ASSIGN_SUCCESS,
  PRODUCT_HISTORY_LIST_SUCCESS,
  PRODUCT_IMPORT_SUCCESS,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_NEW_CARE_SUCCESS,
  PRODUCT_ONE_SUCCESS,
  PRODUCT_UPDATE_FILTER,

  PRODUCT_UPDATE_HOMEPAGE_FILTER,
  PRODUCT_HOMEPAGE_LIST_SUCCESS,
  PRODUCT_HOMEPAGE_ONE_SUCCESS,

  PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER,
  PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS,
  PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/product.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter_1: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter_2: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter_3: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter_4: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter_5: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductLimitPage: 0,
    homepageProductLimitLimit: DEFAULT_ROW_PER_PAGE,
  },

  items: [],
  total: 0,
  selected: undefined,

  homepageProductItems: [],
  homepageProductTotal: 0,
  homepageProductSelected: undefined,

  homepageProductItems_1: [],
  homepageProductTotal_1: 0,
  homepageProductSelected_1: undefined,

  homepageProductItems_2: [],
  homepageProductTotal_2: 0,
  homepageProductSelected_2: undefined,

  homepageProductItems_3: [],
  homepageProductTotal_3: 0,
  homepageProductSelected_3: undefined,

  homepageProductItems_4: [],
  homepageProductTotal_4: 0,
  homepageProductSelected_4: undefined,

  homepageProductItems_5: [],
  homepageProductTotal_5: 0,
  homepageProductSelected_5: undefined,

  homepageProductLimitItems: [],
  homepageProductLimitTotal: 0,
  homepageProductLimitSelected: undefined,

  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const productReducer = (state = initState, action) => {
  switch (action.type) {
    case PRODUCT_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case PRODUCT_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case PRODUCT_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter !== 'undefined' && state.homepageProductFilter) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageProductItems: action.data.homepageProductItems,
        homepageProductTotal: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageProductSelected: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER + '_1':  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter_1 !== 'undefined' && state.homepageProductFilter_1) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter_1.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter_1.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter_1.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter_1.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter_1: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS + '_1': {
      return {
        ...state,
        homepageProductItems_1: action.data.homepageProductItems,
        homepageProductTotal_1: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS + '_1': {
      return {
        ...state,
        homepageProductSelected_1: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER + '_2':  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter_2 !== 'undefined' && state.homepageProductFilter_2) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter_2.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter_2.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter_2.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter_2.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter_2: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS + '_2': {
      return {
        ...state,
        homepageProductItems_2: action.data.homepageProductItems,
        homepageProductTotal_2: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS + '_2': {
      return {
        ...state,
        homepageProductSelected_2: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER + '_3':  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter_3 !== 'undefined' && state.homepageProductFilter_3) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter_3.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter_3.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter_3.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter_3.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter_3: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS + '_3': {
      return {
        ...state,
        homepageProductItems_3: action.data.homepageProductItems,
        homepageProductTotal_3: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS + '_3': {
      return {
        ...state,
        homepageProductSelected_3: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER + '_4':  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter_4 !== 'undefined' && state.homepageProductFilter_4) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter_4.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter_4.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter_4.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter_4.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter_4: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS + '_4': {
      return {
        ...state,
        homepageProductItems_4: action.data.homepageProductItems,
        homepageProductTotal_4: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS + '_4': {
      return {
        ...state,
        homepageProductSelected_4: action.data
      }
    }

    //==========

    case PRODUCT_UPDATE_HOMEPAGE_FILTER + '_5':  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter_5 !== 'undefined' && state.homepageProductFilter_5) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter_5.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter_5.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter_5.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter_5.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter_5: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS + '_5': {
      return {
        ...state,
        homepageProductItems_5: action.data.homepageProductItems,
        homepageProductTotal_5: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS + '_5': {
      return {
        ...state,
        homepageProductSelected_5: action.data
      }
    }

    //==========

    case PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductLimitFilter !== 'undefined' && state.homepageProductLimitFilter) {
        if (action.data.homepageProductLimitPage == 'no_update' && typeof state.homepageProductLimitFilter.homepageProductLimitPage !== 'undefined') action.data.homepageProductLimitPage = state.homepageProductLimitFilter.homepageProductLimitPage;
        if (action.data.homepageProductLimitLimit == 'no_update' && typeof state.homepageProductLimitFilter.homepageProductLimitLimit !== 'undefined') action.data.homepageProductLimitLimit = state.homepageProductLimitFilter.homepageProductLimitLimit;
      }
      return {
        ...state,
        homepageProductLimitFilter: action.data,
      }
    }
    case PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageProductLimitItems: action.data.homepageProductLimitItems,
        homepageProductLimitTotal: action.data.homepageProductLimitTotal,
      }
    }
    case PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageProductLimitSelected: action.data
      }
    }
    case PRODUCT_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case PRODUCT_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case PRODUCT_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case PRODUCT_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default productReducer